<div class="status-badge"
  [style.background-color]="getLighterShade(color, 0.3)"
  [style.color]="color"
  [style.border-color]="color">
  {{ text }}
</div>
